import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./FrontPage.css";
import InfinityButtonImage from "../images/infinitybutton.png";

const FrontPage = () => {
  return (
    <>
      {/* GOOGLE SEO */}
      <Helmet>
        <title>
          BILLI THANNER
        </title>
        <meta
          name="description"
          content="Artist Billi Thanner – Neon Art, Himmelsleiter, Infinity of Light."
        />
      </Helmet>

      <div className="frontpage-layout">
        <div className="menu">
          <ul>
            <li><Link to="/">BILLI&nbsp;THANNER</Link></li>
            <li><Link to="/Work">WORK</Link></li>
            <li><Link to="/About">ABOUT</Link></li>
            <li><Link to="/Exhibitions">EXHIBITIONS</Link></li>
            <li><Link to="/Press">PRESS</Link></li>
            <li><Link to="/Contact">CONTACT</Link></li>
          </ul>
        </div>

        <div className="content-wrapper">
          {/* SEO TEXT (wichtig für Google) */}
          <h1 className="seo-h1">Billi Thanner – Artist</h1>
          <p className="seo-text">
            Neon Art, Himmelsleiter und Infinity of Light.
          </p>

          <div className="infinity-button-wrapper">
            <Link to="/Infinityde">
              <img
                src={InfinityButtonImage}
                alt="InfinityButton"
                className="infinity-button"
              />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default FrontPage;
